import React from "react";

import ReactLoader from "react-loaders"
import "loaders.css";

export default function Loader() {
  return (
    <div style={{padding: 40, display: "flex", justifyContent: "center"}}>
      <style>
        {`
          .loader-inner.pacman > div:nth-child(1) {
            border-right-color: transparent !important;
            z-index: 2 !important;
          }

          .loader-inner.pacman > div:nth-child(2) {
            border-right-color: transparent !important;
            z-index: 2 !important;
          }

          .loader-inner.pacman > div:nth-child(1),
          .loader-inner.pacman > div:nth-child(2) {
            border-top-color: black !important;
            border-left-color: black !important;
            border-bottom-color: black !important;
          }

          .loader-inner.pacman > div:nth-child(3) {
            background-color: #6366F1 !important; /* Purple */
            z-index: 1 !important;
          }

          .loader-inner.pacman > div:nth-child(4) {
            background-color: #EC4899 !important; /* Pink */
            z-index: 1 !important;
          }

          .loader-inner.pacman > div:nth-child(5) {
            background-color: #3B82F6 !important; /* Blue */
            z-index: 1 !important;
          }
        `}
      </style>
      <ReactLoader type="pacman" />
    </div>
  );
}